import { Logger } from "@lululemon/mwa-logger";

export const ERRORS_FINGERPRINTS = {
  LOADING_REVIEWS: "Reviews | Failed to load reviews",
  LOADING_COMMENTS: "Reviews | Failed to load review comments",
  SENDING_DATA_TO_BV_PIXEL: "Reviews | Error sending data to Bazaarvoice Pixel",
  POSTING_CONTENT: "Reviews | Failed to post content",
  POSTING_CONTENT_FEEDBACK: "Reviews | Failed to post content feedback",
  LOADING_REVIEWS_FORM_DATA: "Reviews | Failed to load reviews' form data",
  USER_AUTHENTICATION: "Reviews | User authentication failed",
  UPLOADING_IMAGE: "Reviews | Failed to upload image",
};

// Reviews logger: Use this to log in sentry any reviews error related
const logger = new Logger({
  owner: "guest-confidence-ugc",
  app: "pdp-reviews-app",
});

// We'll keep this function since we can get a string as error, and we must send
// an Error instance to Sentry
function getErrorObject(error) {
  const isErrorMessage = error instanceof String || typeof error === "string";
  const isError = error instanceof Error;

  if (!error || (!isError && !isErrorMessage)) {
    return new Error("Unknown Reviews error.");
  }

  if (isErrorMessage) {
    return new Error(error);
  }

  return error;
}

export const reviewsLogger = ({
  bazaarvoiceId = "",
  error,
  componentName,
  context = {},
  functionName,
  message,
  pdpUrl = "",
  tags = {},
}) => {
  const errorObject = getErrorObject(message);

  const userAuthenticateString = localStorage?.getItem("bazaarvoice_uas") || "";

  logger.error(
    errorObject,
    {
      fingerprint: [message],
      tags: {
        componentName,
        featureName: "Reviews",
        functionName,
        bazaarvoiceId,
        url: pdpUrl,
        isContentAuthorAuthenticated: !!userAuthenticateString,
        ...tags,
      },
    },
    (scope) => {
      scope.setContext("Original Error Object", error);
      scope.setContext("Bazaarvoice data", { Id: bazaarvoiceId });
      scope.setContext("Additional context data", { ...context, error });
    }
  );
};
